import { useGetVersionQuery, useGetRsvTop3LevelsQuery, useGetSectionListQuery } from "../api/apiSlice";
import { iNodeItem, iVersion, iBookSectionList } from "../../dataTypes/dataTypes";

/*
    Compares locally stored version # w/ version from database.
    If they don't match, reload the page.
    While !versionOk, message is toggled to user.
*/
export const useVersion = (): iVersion => {
  const current = localStorage.getItem("version");
  const {
    data,
    isSuccess,
    isLoading,
    isError,
    error,
  } = useGetVersionQuery(null);
  let versionOk = false;
  if (isSuccess) {
    const xversion = data[0].xversion;
    if (current && data.length > 0) {
      if (current === xversion) {
        versionOk = true;
      } else {
        localStorage.setItem('version', xversion)
        window.location.reload();
      }
    } else {
      localStorage.setItem('version', xversion)
      window.location.reload();
    }
  }
  return { data, isSuccess, isLoading, isError, error, versionOk };
}

/*
    Search component begins by loading book list.
*/
export const useBookList = (pid: number): iBookSectionList => {
  /*
  const {
    data = [] as iNodeItem[],
    isSuccess,
    isLoading,
    isError,
    error,
  } = useGetBookListQuery(pid);
  */
  // hardcode for rsv/ccc
  const
    data: iNodeItem[] = [{ "abbrev": "rsv", "pid": 1, "cid": 1, "docid": 1, "hiernode": "/" }, { "abbrev": "ccc", "pid": 1, "cid": 36883, "docid": 2, "hiernode": "/" }],
    isSuccess = true,
    isLoading = false,
    isError = false,
    error = "none"

  return { data, isSuccess, isLoading, isError, error };
}

/*
    Get RSV top 3 section levels root, ot/nt, book
*/
export const useRsvTop3Levels = (pid: number): iBookSectionList => {
  const {
    data = [] as iNodeItem[],
    isSuccess,
    isLoading,
    isError,
    error,
  } = useGetRsvTop3LevelsQuery(pid);
  return { data, isSuccess, isLoading, isError, error };
}

// hardcode rsv books
const rsvBooks: iNodeItem[] =
  [{ "abbrev": "rsv", "pid": 1, "cid": 1, "docid": 1, "hiernode": "/" }, { "abbrev": "ot", "pid": 1, "cid": 2, "docid": 1, "hiernode": "/1/" }, { "abbrev": "gen", "pid": 1, "cid": 3, "docid": 1, "hiernode": "/1/1/" }, { "abbrev": "ex", "pid": 1, "cid": 1587, "docid": 1, "hiernode": "/1/2/" }, { "abbrev": "lev", "pid": 1, "cid": 2841, "docid": 1, "hiernode": "/1/3/" }, { "abbrev": "num", "pid": 1, "cid": 3728, "docid": 1, "hiernode": "/1/4/" }, { "abbrev": "deut", "pid": 1, "cid": 5053, "docid": 1, "hiernode": "/1/5/" }, { "abbrev": "josh", "pid": 1, "cid": 6047, "docid": 1, "hiernode": "/1/6/" }, { "abbrev": "judg", "pid": 1, "cid": 6730, "docid": 1, "hiernode": "/1/7/" }, { "abbrev": "ruth", "pid": 1, "cid": 7370, "docid": 1, "hiernode": "/1/8/" }, { "abbrev": "1sam", "pid": 1, "cid": 7460, "docid": 1, "hiernode": "/1/9/" }, { "abbrev": "2sam", "pid": 1, "cid": 8302, "docid": 1, "hiernode": "/1/10/" }, { "abbrev": "1kings", "pid": 1, "cid": 9022, "docid": 1, "hiernode": "/1/11/" }, { "abbrev": "2kings", "pid": 1, "cid": 9861, "docid": 1, "hiernode": "/1/12/" }, { "abbrev": "1chr", "pid": 1, "cid": 10606, "docid": 1, "hiernode": "/1/13/" }, { "abbrev": "2chr", "pid": 1, "cid": 11578, "docid": 1, "hiernode": "/1/14/" }, { "abbrev": "ezra", "pid": 1, "cid": 12437, "docid": 1, "hiernode": "/1/15/" }, { "abbrev": "neh", "pid": 1, "cid": 12728, "docid": 1, "hiernode": "/1/16/" }, { "abbrev": "tob", "pid": 1, "cid": 13148, "docid": 1, "hiernode": "/1/17/" }, { "abbrev": "jud", "pid": 1, "cid": 13406, "docid": 1, "hiernode": "/1/18/" }, { "abbrev": "esth", "pid": 1, "cid": 13762, "docid": 1, "hiernode": "/1/19/" }, { "abbrev": "1mac", "pid": 1, "cid": 14055, "docid": 1, "hiernode": "/1/20/" }, { "abbrev": "2mac", "pid": 1, "cid": 14996, "docid": 1, "hiernode": "/1/21/" }, { "abbrev": "job", "pid": 1, "cid": 15567, "docid": 1, "hiernode": "/1/22/" }, { "abbrev": "ps", "pid": 1, "cid": 16680, "docid": 1, "hiernode": "/1/23/" }, { "abbrev": "prov", "pid": 1, "cid": 19408, "docid": 1, "hiernode": "/1/24/" }, { "abbrev": "eccl", "pid": 1, "cid": 20355, "docid": 1, "hiernode": "/1/25/" }, { "abbrev": "song", "pid": 1, "cid": 20590, "docid": 1, "hiernode": "/1/26/" }, { "abbrev": "wis", "pid": 1, "cid": 20716, "docid": 1, "hiernode": "/1/27/" }, { "abbrev": "sir", "pid": 1, "cid": 21172, "docid": 1, "hiernode": "/1/28/" }, { "abbrev": "isa", "pid": 1, "cid": 22583, "docid": 1, "hiernode": "/1/29/" }, { "abbrev": "jer", "pid": 1, "cid": 23942, "docid": 1, "hiernode": "/1/30/" }, { "abbrev": "lam", "pid": 1, "cid": 25359, "docid": 1, "hiernode": "/1/31/" }, { "abbrev": "bar", "pid": 1, "cid": 25519, "docid": 1, "hiernode": "/1/32/" }, { "abbrev": "ezek", "pid": 1, "cid": 25664, "docid": 1, "hiernode": "/1/33/" }, { "abbrev": "dan", "pid": 1, "cid": 26986, "docid": 1, "hiernode": "/1/34/" }, { "abbrev": "hos", "pid": 1, "cid": 27534, "docid": 1, "hiernode": "/1/35/" }, { "abbrev": "joel", "pid": 1, "cid": 27746, "docid": 1, "hiernode": "/1/36/" }, { "abbrev": "amos", "pid": 1, "cid": 27823, "docid": 1, "hiernode": "/1/37/" }, { "abbrev": "oba", "pid": 1, "cid": 27979, "docid": 1, "hiernode": "/1/38/" }, { "abbrev": "jonah", "pid": 1, "cid": 28001, "docid": 1, "hiernode": "/1/39/" }, { "abbrev": "mic", "pid": 1, "cid": 28054, "docid": 1, "hiernode": "/1/40/" }, { "abbrev": "nah", "pid": 1, "cid": 28167, "docid": 1, "hiernode": "/1/41/" }, { "abbrev": "hab", "pid": 1, "cid": 28218, "docid": 1, "hiernode": "/1/42/" }, { "abbrev": "zeph", "pid": 1, "cid": 28278, "docid": 1, "hiernode": "/1/43/" }, { "abbrev": "hag", "pid": 1, "cid": 28335, "docid": 1, "hiernode": "/1/44/" }, { "abbrev": "zech", "pid": 1, "cid": 28376, "docid": 1, "hiernode": "/1/45/" }, { "abbrev": "mal", "pid": 1, "cid": 28602, "docid": 1, "hiernode": "/1/46/" }, { "abbrev": "nt", "pid": 1, "cid": 28662, "docid": 1, "hiernode": "/2/" }, { "abbrev": "mt", "pid": 1, "cid": 28663, "docid": 1, "hiernode": "/2/1/" }, { "abbrev": "mk", "pid": 1, "cid": 29758, "docid": 1, "hiernode": "/2/2/" }, { "abbrev": "lk", "pid": 1, "cid": 30448, "docid": 1, "hiernode": "/2/3/" }, { "abbrev": "jn", "pid": 1, "cid": 31618, "docid": 1, "hiernode": "/2/4/" }, { "abbrev": "acts", "pid": 1, "cid": 32518, "docid": 1, "hiernode": "/2/5/" }, { "abbrev": "rom", "pid": 1, "cid": 33550, "docid": 1, "hiernode": "/2/6/" }, { "abbrev": "1cor", "pid": 1, "cid": 33999, "docid": 1, "hiernode": "/2/7/" }, { "abbrev": "2cor", "pid": 1, "cid": 34453, "docid": 1, "hiernode": "/2/8/" }, { "abbrev": "gal", "pid": 1, "cid": 34724, "docid": 1, "hiernode": "/2/9/" }, { "abbrev": "eph", "pid": 1, "cid": 34880, "docid": 1, "hiernode": "/2/10/" }, { "abbrev": "phil", "pid": 1, "cid": 35042, "docid": 1, "hiernode": "/2/11/" }, { "abbrev": "col", "pid": 1, "cid": 35151, "docid": 1, "hiernode": "/2/12/" }, { "abbrev": "1thes", "pid": 1, "cid": 35251, "docid": 1, "hiernode": "/2/13/" }, { "abbrev": "2thes", "pid": 1, "cid": 35346, "docid": 1, "hiernode": "/2/14/" }, { "abbrev": "1tim", "pid": 1, "cid": 35397, "docid": 1, "hiernode": "/2/15/" }, { "abbrev": "2tim", "pid": 1, "cid": 35517, "docid": 1, "hiernode": "/2/16/" }, { "abbrev": "titus", "pid": 1, "cid": 35605, "docid": 1, "hiernode": "/2/17/" }, { "abbrev": "philem", "pid": 1, "cid": 35655, "docid": 1, "hiernode": "/2/18/" }, { "abbrev": "heb", "pid": 1, "cid": 35681, "docid": 1, "hiernode": "/2/19/" }, { "abbrev": "jas", "pid": 1, "cid": 35998, "docid": 1, "hiernode": "/2/20/" }, { "abbrev": "1pet", "pid": 1, "cid": 36111, "docid": 1, "hiernode": "/2/21/" }, { "abbrev": "2pet", "pid": 1, "cid": 36222, "docid": 1, "hiernode": "/2/22/" }, { "abbrev": "1jn", "pid": 1, "cid": 36287, "docid": 1, "hiernode": "/2/23/" }, { "abbrev": "2jn", "pid": 1, "cid": 36398, "docid": 1, "hiernode": "/2/24/" }, { "abbrev": "3jn", "pid": 1, "cid": 36413, "docid": 1, "hiernode": "/2/25/" }, { "abbrev": "jude", "pid": 1, "cid": 36430, "docid": 1, "hiernode": "/2/26/" }, { "abbrev": "rev", "pid": 1, "cid": 36456, "docid": 1, "hiernode": "/2/27/" }];

/*
    Search component begins by loading book list.
*/
export const useSectionList = (pid: number, book: iNodeItem | null, sections: iNodeItem[]): iBookSectionList => {
  //
  let textnode = "";
  let skip = false;
  if (!book || sections.length < 2) {
    skip = true;
  }
  /*
  let 
    data : iNodeItem[] = [],
    isSuccess = false,
    isLoading = false, 
    isError = false,
    error = "none"
  */
  //
  const l = sections.length;
  if (l === 0) {
    textnode = "/";
  } else {
    textnode = sections[l - 1].hiernode;
  }
  //
  let {
    data = [],
    isSuccess,
    isLoading,
    isError,
    error = "none"
  } = useGetSectionListQuery({
    pid: pid,
    docid: book ? book.docid : -1,
    textnode
  }, { skip: skip });

  if (skip && book && book.abbrev === 'rsv') {
    isSuccess = true;
    isLoading = false;
    isError = false;
    data = rsvBooks.filter((n) => {
      let r = false;
      //
      if (textnode.length === 1 && n.hiernode.length === 3) {
        r = true;
      }
      if (textnode.length === 3 && n.hiernode.length > 3 && n.hiernode.startsWith(textnode)) {
        r = true;
      }
      return r;
    })
  }
  return { data, isSuccess, isLoading, isError, error };
}


/*
    if (textnode.length === 1) {
      data = [{ "abbrev": "ot", "pid": 1, "cid": 2, "docid": 1, "hiernode": "/1/" },{ "abbrev": "nt", "pid": 1, "cid": 28662, "docid": 1, "hiernode": "/2/" }];
    }
    if (textnode.length === 3 ) {
      data = [{ "abbrev": "ot", "pid": 1, "cid": 2, "docid": 1, "hiernode": "/1/" },{ "abbrev": "nt", "pid": 1, "cid": 28662, "docid": 1, "hiernode": "/2/" }];
    }

*/
